<div class="message-report-sent">
    <div class="message-report-sent__img"></div>
    <div class="message-report-sent__text">
        {{TEXT.others.messageReportSendStart}} «{{nameReport}}»
        <span class="message-report-sent__text-bold">{{statusReport}}</span>
    </div>
</div>